// @ts-strict-ignore
import {Component, Input} from "@angular/core";
import {SimUser} from "@models";

@Component({
	selector: "sim-horizontal-user-bubbles",
	templateUrl: "./horizontal-user-bubbles.component.html",
	styleUrls: ["./horizontal-user-bubbles.component.scss"],
	standalone: false,
})
export class HorizontalUserBubblesComponent {
	@Input() users: SimUser[];
	@Input() usersToShow: number = 2;
	@Input() big = false;

	constructor() {}

	get firstUsers(): SimUser[] {
		return this.users?.slice(0, this.usersToShow) ?? [];
	}

	get hasAdditionalUsers(): boolean {
		return this.users?.length > this.usersToShow;
	}

	get remainingUsersTooltip(): string {
		return (
			this.users
				?.slice(this.usersToShow)
				?.map((user) => user?.fullname)
				?.join("\n") ?? ""
		);
	}
}
